const plugin = {
    id: 'chart-doughnut',
    beforeDraw: function (chart) {
        let width = chart.chart.width,
            height = chart.chart.height,
            ctx = chart.chart.ctx

        ctx.restore()

        let fontSize = 0.9
        ctx.font = `${fontSize}em sans-serif`
        ctx.textBaseline = 'middle'
        ctx.fillStyle = '#009ada'

        let text = `${chart.chart.config.data.datasets[0].data[0]}%`,
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2

        ctx.fillText(text, textX, textY)
        ctx.save()
    },
}

export default plugin
